import { render, staticRenderFns } from "./GetReq.vue?vue&type=template&id=664aca08&"
import script from "./GetReq.vue?vue&type=script&lang=js&"
export * from "./GetReq.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports